<script lang="ts">
export default {
    name: 'ExportButton',
    props: {
        translationName: { type: String, required: true },
        requestName: { type: String, required: true },
        exportable: { type: Array, required: true },
        query: {
            type: Object,
            required: false,
            default: () => {
            },
        },
        btnStyle: { type: Object, required: false },
        showDisabled: { type: Boolean, required: false },
        mailMe: { type: Boolean, required: false, default: false },
    },
    data() {
        return {
            dialog: false,
            loading: false,

            type: null,
            error: false,
            initExport: false,
            checkInterval: null,
            exportData: {
                percent: 0,
            },
        }
    },
    watch: {
        dialog() {
            if (!this.dialog) {
                this.loading = false
                this.error = false
                this.initExport = false
                this.exportData = {
                    percent: 0,
                }
            }
        },
    },
    methods: {
        getMinutesTimer(time) {
            const minutes = Math.floor(time / 60)
            const seconds = time - minutes * 60

            return `${minutes > 0 ? `${minutes}min ` : ''}${seconds}s`
        },
        getExport(type) {
            this.type = type
            this.loading = true
            this.initExport = true

            this.$api.setRequest({
                url: `${this.requestName}?export=${type}&mail_me=${this.mailMe}`,
                query: this.query,
                method: 'GET',

            }).then((res) => {
                this.exportData = res.data
                this.checkInterval = setInterval(() => {
                    this.checkExportPercent('GET')
                }, 1000)
                // this.loading = false
            }).catch(() => {
                this.error = true

                this.loading = false
                this.initExport = false
            })
        },
        checkExportPercent(method, body) {
            this.$api.setRequest({
                url: `processings/${this.exportData.hash}`, // {{host}}/processings/{{processHash}}
                method,
                body,
            }).then((res) => {
                this.initExport = res.data.status === 'new'
                this.exportData = res.data

                if (this.exportData.status === 'done') {
                    clearInterval(this.checkInterval)
                    this.loading = false
                }
                if (this.exportData.status === 'failed') {
                    clearInterval(this.checkInterval)
                    this.error = true
                    this.loading = false
                }
            })
        },
        setupMailNotification(value) {
            this.checkExportPercent('PUT', { mail_me: value })
            this.cancel()
        },
        cancel() {
            clearInterval(this.checkInterval)
            this.dialog = false
            this.exportData = {
                percent: 0,
            }
        },
    },
}
</script>

<template>
    <template v-if="$permissionCheck('processing_index') && $permissionCheck('processing_show') && $permissionCheck('processing_update')">
        <template v-if="exportable && exportable.length">
            <v-menu>
                <template #activator="{ props }">
                    <v-btn
                        v-bind="props"
                        color="primary"
                        :variant="btnStyle?.variant || 'elevated'"
                        :size="btnStyle?.size || 'default'"
                        :class="btnStyle?.class || ''"
                        :loading="loading"
                        :style="$vuetify.display.width < 400 ? 'height: auto; padding: 10px' : ''"
                    >
                        <v-icon icon="mdi-export" class="pr-3" />
                        <p style="white-space: normal;">
                            {{ $translate(`${translationName}.export`) }}
                        </p>
                    </v-btn>
                </template>

                <v-list>
                    <v-list-item
                        v-for="(item, index) in exportable"
                        :key="index"
                        class="pa-0"
                        :value="index"
                    >
                        <v-list-item-title @click="dialog = true; getExport(item)">
                            <span class="px-4 py-2">
                                {{ $translate(`export.${item}`) !== `export.${item}` ? $translate(`export.${item}`) : item }}
                            </span>
                        </v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>

            <!-- MODAL EXPORT % -->
            <v-dialog
                v-model="dialog"
                persistent
                width="auto"
                min-width="500"
            >
                <v-card>
                    <v-card-title class="text-right">
                        <v-btn
                            icon="mdi-close"
                            variant="text"
                            @click="cancel"
                        />
                    </v-card-title>

                    <v-card-text
                        v-if="error"
                        class="text-red text-center text-caption"
                    >
                        Une erreur s'est produite lors de votre export.
                    </v-card-text>
                    <v-card-text
                        v-if="error"
                        class="text-red text-center text-caption"
                    >
                        <b>{{ exportData.info }}</b>
                    </v-card-text>
                    <v-card-text class="text-center">
                        <div class="text-caption mb-5">
                            <i v-if="initExport">Préparation de votre export {{ type }}</i>
                            <i v-else-if="exportData.download_url">Export {{ type }} terminé</i>
                            <i v-else-if="!error">Export {{ type }} en cours<br>
                                Temps restant estimé :
                                {{ getMinutesTimer(exportData.estimated_duration - exportData.duration) }}
                            </i>
                        </div>
                        <v-progress-linear
                            v-model="exportData.percent"
                            class="mb-10 mt-2"
                            striped
                            :indeterminate="initExport"
                            rounded
                            :color="error ? 'danger' : 'primary'"
                            height="25"
                        >
                            <strong v-if="!initExport">{{ exportData.percent.toFixed(1) }} %</strong>
                        </v-progress-linear>

                        <DocumentsDownloadLink
                            v-if="exportData.download_url && exportData.status === 'done'"
                            :filename="exportData.filename"
                            :url="`/processings/${exportData.hash}/download`"
                            @click="cancel"
                        >
                            <v-btn
                                color="info"
                                prepend-icon="mdi-download"
                                :variant="$config.public.chips_variant || 'tonal'"
                            >
                                Télécharger votre export
                            </v-btn>
                        </DocumentsDownloadLink>
                    </v-card-text>

                    <v-card-actions
                        class="text-center"
                    >
                        <!-- SETUP MAIL NOTIFICATION -->
                        <template v-if="exportData?.status !== 'done' && exportData?.status !== 'failed' && !error">
                            <v-btn
                                v-if="exportData.hash"
                                color="dark"
                                :variant="$config.public.chips_variant || 'tonal'"
                                @click="setupMailNotification(true)"
                            >
                                Fermer la fenêtre et recevoir un e-mail avec un lien de téléchargement
                            </v-btn>
                        </template>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </template>
        <v-tooltip v-else-if="(!exportable || !exportable.length) && showDisabled" text="Aucun type d'export disponible">
            <template #activator="{ props }">
                <v-btn
                    disabled
                    color="primary"
                    :variant="btnStyle.variant"
                    :size="btnStyle.size"
                    :class="btnStyle.class"
                    :style="$vuetify.display.width < 400 ? 'height: auto; padding: 10px' : ''"
                >
                    <v-icon
                        icon="mdi-export"
                        class="pr-3"
                    />
                    <p style="white-space: normal;">
                        {{ $translate(`${translationName}.export`) }}
                    </p>
                </v-btn>
            </template>
        </v-tooltip>
    </template>
</template>
